import axios from "axios";

const crmClient = axios.create({
  baseURL: process.env.REACT_APP_CRM_URL || "https://crm.binnysjewellery.in/api",
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    projectDetails: "CRMWeb",
  },
});

crmClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default crmClient;
